import Section from "~/cabinet/vue/layout/lcab/Aside/Section";
import RouteHelper from "~/core-ui/ts/router/RouteHelper";
import {AccountStore} from "~/cabinet/ts/store/AccountStore";
import DealerRoutesBuilder, {DEALER_ROOT_NAME} from "~/cabinet/ts/routes/DealerRoutesBuilder";
import {__} from "~/ts/library/Translate";
import {RouteRecordRaw, useRouter} from "vue-router";
import RouteAccessChecker from "~/cabinet/ts/routes/RouteAccessChecker";
import ClientRoutesBuilder from "~/cabinet/ts/routes/ClientRoutesBuilder";
import {computed} from "vue";
import {IRouteMeta} from "~/core-ui/ts/router/Interface";
import {useMyRouter} from "~/core-ui/ts/router/useMyRouter";

export function useSectionSelector(onSelect: (section: Section) => void) {
    let router = useRouter();
    let route = router.currentRoute;


    let sectionList = computed<Section[]>(() => {
        let result: Section[];
        if (RouteHelper.isRouteForDealer(route.value)) {
            result = dealerSectionsList.value;
        } else {
            result = [...clientSectionsList.value];

            if (AccountStore.isDealer.value) {
                result.push(new Section(DEALER_ROOT_NAME, __("Управление"), "cubes"));
            }
        }
        return [...result].filter(section => section.isVisibleInMenu);
    });

    function getSectionsListByRoutes(routes: RouteRecordRaw[]): Section[] {
        return routes
            .filter(route => RouteAccessChecker.checkAccessByMeta(route.meta))
            .map((route: RouteRecordRaw) => route.meta ? (route.meta as IRouteMeta).section : null)
            .filter(section => section != null);
    }

    let dealerSectionsList = computed<Section[]>(() => {
        return getSectionsListByRoutes((new DealerRoutesBuilder()).make()[0].children);

    });

    function getClientSectionsList(collapseSenders?: boolean) {
        let result = getSectionsListByRoutes((new ClientRoutesBuilder()).make(collapseSenders)[0].children);
        if (result.length > 1) {
            result = result.filter(section => /*section.routeName != CLIENT_START_ROUTE_NAME &&*/ section.isVisibleInMenu);
        }
        return result;
    }

    let clientSectionsList = computed<Section[]>(() => {
        let result = getClientSectionsList();

        let sectionsInConfig = AccountStore.dealerCabinetConfig.value.menu.sections;

        result.sort((a, b) => {
            let weight1 = sectionsInConfig[a.routeName.toString()] ? sectionsInConfig[a.routeName.toString()].weight : -1;
            let weight2 = sectionsInConfig[b.routeName.toString()] ? sectionsInConfig[b.routeName.toString()].weight : -1;
            if (weight1 == -1) {
                weight1 = result.indexOf(a);
            }
            if (weight2 == -1) {
                weight2 = result.indexOf(b);
            }
            if (weight1 > weight2) {
                return 1;
            }
            if (weight2 > weight1) {
                return -1;
            }
            return 0;
        });
        for (let section of result) {
            let sectionConfig = sectionsInConfig[section.routeName.toString()];
            if (sectionConfig) {
                if (sectionConfig.icon) {
                    section.replaceIcon(sectionConfig.icon);
                }
                if (sectionConfig.descr) {
                    section.replaceDescr(sectionConfig.descr);
                }
            }
        }

        return result;
    });


    let currentSection = computed<Section>(() => {
        let routeRecord = route.value.matched.find(route => !!route.meta.section);
        return routeRecord ? (routeRecord.meta as IRouteMeta).section : new Section(route.value.path, route.value.path);
    });

    async function select(section: Section) {
        let element = document.getElementById("lcab-aside");
        if (element && element.scroll) {
            element.scroll(0, 0);
        }
        try {
            await useMyRouter().push(getPathForSection(section));
        } catch (e) {

        }
        onSelect(section);
    }

    function getPathForSection(section: Section) {
        return {name: section.routeName};
    }

    return {
        sectionList,
        getClientSectionsList,
        currentSection,
        select,
        getPathForSection
    }
}